/**
 * src/lib/stories.js — nhận câu chuyện gọi vốn do founder tự gửi.
 *
 * VÌ SAO KHÔNG DÙNG mailto: mailto phụ thuộc vào ứng dụng mail mặc định trên
 * máy người dùng. Trên Windows chưa gán Outlook, hoặc trên máy dùng Gmail
 * trong trình duyệt, click vào chỉ hiện địa chỉ ở góc màn hình rồi không có
 * gì xảy ra. Người muốn kể chuyện sẽ bỏ đi. Form lưu thẳng vào Firestore giữ
 * được câu chuyện ngay cả khi họ không có ứng dụng mail.
 *
 * KHÔNG CẦN ĐĂNG NHẬP — đúng nguyên tắc của site. Bù lại, Firestore Rules
 * kiểm tra kích thước và tên trường; trình duyệt chỉ được ghi, không đọc lại.
 */
import { layDb } from './firebase.js';

export const EMAIL_LIEN_HE = 'xin-chao@fundraising.vn';
export const GIAI_DOAN = ['Chưa gọi vốn', 'Đang chuẩn bị', 'Đang gọi vốn', 'Đã gọi xong', 'Gọi không thành'];
export const KET_QUA = ['Thành công', 'Chưa thành công', 'Đang tiếp diễn', 'Không muốn nói'];

const cat = (v, max) => String(v ?? '').trim().slice(0, max);

export function chuanHoaCauChuyen(raw = {}) {
  return {
    hoTen: cat(raw.hoTen, 120),
    lienHe: cat(raw.lienHe, 160),
    congTy: cat(raw.congTy, 160),
    nganh: cat(raw.nganh, 120),
    giaiDoan: GIAI_DOAN.includes(raw.giaiDoan) ? raw.giaiDoan : GIAI_DOAN[0],
    ketQua: KET_QUA.includes(raw.ketQua) ? raw.ketQua : KET_QUA[3],
    tieuDe: cat(raw.tieuDe, 200),
    cauChuyen: cat(raw.cauChuyen, 6000),
    baiHoc: cat(raw.baiHoc, 2000),
    anDanh: Boolean(raw.anDanh),
    dongY: Boolean(raw.dongY),
    chophepLienHe: Boolean(raw.chophepLienHe),
  };
}

export function kiemTraCauChuyen(s) {
  const loi = [];
  if (s.cauChuyen.length < 150) loi.push('Hãy kể ít nhất vài dòng về tình huống (tối thiểu 150 ký tự) để người đọc hiểu được bối cảnh.');
  if (!s.dongY) loi.push('Cần đồng ý để chúng tôi liên hệ lại trước khi biên tập và đăng.');
  if (!s.anDanh && !s.lienHe) loi.push('Hãy để lại email hoặc số Zalo để chúng tôi xác nhận bản cuối với bạn.');
  if (s.anDanh && !s.lienHe) loi.push('Kể cả khi đăng ẩn danh, chúng tôi vẫn cần một cách liên hệ riêng với bạn.');
  return loi;
}

/** Ghi câu chuyện vào Firestore. Trình duyệt không đọc lại được collection này. */
export async function guiCauChuyen(raw) {
  const story = chuanHoaCauChuyen(raw);
  const loi = kiemTraCauChuyen(story);
  if (loi.length) throw new Error(loi.join(' '));
  const db = await layDb();
  if (!db) throw new Error(`Website chưa kết nối được máy chủ. Bạn gửi tạm qua email ${EMAIL_LIEN_HE} nhé.`);
  const { collection, addDoc, serverTimestamp } = await import('firebase/firestore/lite');
  await addDoc(collection(db, 'story_submissions'), { ...story, status: 'NEW', createdAt: serverTimestamp() });
  return story;
}

/** Mở sẵn thư trong Gmail trên web — phương án phụ, không cần ứng dụng mail. */
export function linkGmail(tieuDe = 'Góp câu chuyện gọi vốn cho Playbook') {
  return `https://mail.google.com/mail/?view=cm&fs=1&to=${EMAIL_LIEN_HE}&su=${encodeURIComponent(tieuDe)}`;
}

/** Danh sách câu chuyện đã gửi — chỉ tài khoản quản trị đọc được (theo Rules). */
export async function docCauChuyenGui(limit = 50) {
  const db = await layDb();
  if (!db) throw new Error('Website chưa cấu hình Firestore.');
  const { collection, getDocs, query, orderBy, limit: gioiHan } = await import('firebase/firestore/lite');
  const snap = await getDocs(query(collection(db, 'story_submissions'), orderBy('createdAt', 'desc'), gioiHan(limit)));
  return snap.docs.map((d) => {
    const data = d.data();
    return { id: d.id, ...chuanHoaCauChuyen(data), status: data.status || 'NEW',
      createdAt: data.createdAt?.toDate ? data.createdAt.toDate().toISOString().slice(0, 10) : '' };
  });
}

export async function datTrangThaiCauChuyen(id, status) {
  const db = await layDb();
  const { doc, setDoc } = await import('firebase/firestore/lite');
  await setDoc(doc(db, 'story_submissions', id), { status }, { merge: true });
}
